/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementEditShowResponse } from './ShowManagementEditShowResponse';

export type ShowManagementEditShowResponseApiRespoonse = {
    data?: ShowManagementEditShowResponse;
    status?: ShowManagementEditShowResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementEditShowResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

